import { memo } from 'react';

/**
 * Séparateur de vacances scolaires dans la frise de progression : bandeau
 * purement décoratif inséré entre deux séquences quand des vacances s'y
 * intercalent — c'est précisément là que l'import coupe une séquence en
 * « Partie 1 / Partie 2 » (calculateSequenceDates), le bandeau matérialise
 * donc le POURQUOI du trou de dates. Aucune interaction, aucune donnée
 * back : l'affichage vient de fetchSchoolHolidays (API calendrier + repli
 * statique Réunion), et son absence laisse la frise inchangée.
 */
const formatDate = (iso) =>
    new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });

const VacancesSeparator = ({ title, start, end }) => (
    <div
        className="relative z-10 flex justify-center"
        role="note"
        aria-label={`${title} du ${formatDate(start)} au ${formatDate(end)}`}
    >
        <div className="w-full max-w-md sm:max-w-lg bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 border-2 border-dashed border-amber-300 rounded-2xl shadow-sm px-4 py-3 sm:px-6 flex items-center justify-center gap-3">
            <span className="text-xl sm:text-2xl" aria-hidden="true">🌴</span>
            <div className="text-center">
                <p className="font-bold text-amber-800 text-sm sm:text-base">{title}</p>
                <p className="text-amber-700 text-xs sm:text-sm">
                    du {formatDate(start)} au {formatDate(end)}
                </p>
            </div>
            <span className="text-xl sm:text-2xl" aria-hidden="true">🌴</span>
        </div>
    </div>
);

export default memo(VacancesSeparator);
